export default "__VITE_PUBLIC_ASSET__28a2f93a__"